import { enumXMLType } from "../constants";
import { XML_DrawTextPPT } from "./XML_DrawTextPPT";
import { XML_DrawTextPDF } from "./XML_DrawTextPDF";

export function XML_DrawText(
  theMessage,
  x,
  y,
  textColor,
  fontFamily,
  fontSize,
  bold,
  italic,
  underline,
  alignment,
  vAlignment,
  clipRect,
  drawElement,
  layer,
  width = null
) {
  if (theMessage.length == 0) return;
  var docType = drawElement.GetDocType();

  if (docType == enumXMLType.PDF) {
    XML_DrawTextPDF(
      theMessage,
      x,
      y,
      textColor,
      fontFamily,
      fontSize,
      bold,
      italic,
      underline,
      alignment,
      vAlignment,
      clipRect,
      drawElement,
      layer
    );
  } else {
    if (!Array.isArray(theMessage)) theMessage = [[theMessage], []];
    XML_DrawTextPPT(
      theMessage,
      x,
      y,
      textColor,
      fontFamily,
      fontSize,
      bold,
      italic,
      underline,
      alignment,
      vAlignment,
      clipRect,
      drawElement,
      layer,
      width
    );
  }
}
